import React from 'react';
import ClockIcon from '@assets/icons/clock.svg';
import BellIcon from '@assets/icons/notifications/bell.svg';
import RefreshArrowsIcon from '@assets/icons/refresh-arrows.svg';
import StarsIcon from '@assets/icons/stars.svg';
import TagIcon from '@assets/icons/tag.svg';
import { TEST_IDS } from '@constants/testIds.ts';
import { BodyXsXsMedium } from '@constants/text.ts';
import { getLearningStatus } from '@routes/sidebar/___shared___/utils.ts';
import type { LearningResponse } from '@routes/sidebar/learning/api/learning.api.ts';
import {
    SHARED_CARD_PILL_LABELS_DUE_SOON,
    SHARED_CARD_PILL_LABELS_OVERDUE,
    SHARED_CARD_PILL_LABELS_REFRESHER,
    SHARED_CARD_PILL_LABELS_UPDATED,
} from '@routes/sidebar/learning/ui/learning-tab/card-pill-labels/constants.ts';
import {
    CardPillIcon,
    CardPillLabel,
    CardPillLabelsWrapper,
    CardPills,
    PillDueSoon,
    PillOverdue,
    PillRefresher,
    PillsStatus,
    PillUpdated,
    Spacer,
} from '@routes/sidebar/learning/ui/learning-tab/card-pill-labels/styled.tsx';
import { translateItem } from '@utils/translations.ts';

interface Props {
    learning: LearningResponse;
    serverTime: Date;
}

const CardPillLabels: React.FC<Props> = ({ learning, serverTime }) => {
    const { isOverdue, isRefresher, isUpdated, isDueSoon } = getLearningStatus(learning, serverTime);

    return (
        <CardPillLabelsWrapper>
            <CardPills>
                <CardPillLabel data-cy={TEST_IDS.LEARNING.CARD_PILL_FOCUS}>
                    <CardPillIcon>
                        <TagIcon />
                    </CardPillIcon>
                    <BodyXsXsMedium>{learning.learningDetails.category.focus}</BodyXsXsMedium>
                </CardPillLabel>
                <Spacer />
                <PillsStatus>
                    <>
                        {!!isOverdue && (
                            <PillOverdue data-cy={TEST_IDS.LEARNING.CARD_PILL_OVERDUE}>
                                <ClockIcon />
                                <BodyXsXsMedium>{translateItem(SHARED_CARD_PILL_LABELS_OVERDUE)}</BodyXsXsMedium>
                            </PillOverdue>
                        )}
                        {!!isDueSoon && (
                            <PillDueSoon data-cy={TEST_IDS.LEARNING.CARD_PILL_DUE_SOON}>
                                <BellIcon />
                                <BodyXsXsMedium>{translateItem(SHARED_CARD_PILL_LABELS_DUE_SOON)}</BodyXsXsMedium>
                            </PillDueSoon>
                        )}
                        {!!isRefresher && (
                            <PillRefresher data-cy={TEST_IDS.LEARNING.CARD_PILL_REFRESHER}>
                                <RefreshArrowsIcon />
                                <BodyXsXsMedium>{translateItem(SHARED_CARD_PILL_LABELS_REFRESHER)}</BodyXsXsMedium>
                            </PillRefresher>
                        )}
                        {!!isUpdated && (
                            <PillUpdated data-cy={TEST_IDS.LEARNING.CARD_PILL_UPDATED}>
                                <StarsIcon />
                                <BodyXsXsMedium>{translateItem(SHARED_CARD_PILL_LABELS_UPDATED)}</BodyXsXsMedium>
                            </PillUpdated>
                        )}
                    </>
                </PillsStatus>
            </CardPills>
        </CardPillLabelsWrapper>
    );
};

export default CardPillLabels;
